module.exports = __webpack_public_path__ + "bandon-better-breathing-balance-workshop-feb-17.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bandon-better-breathing-balance-workshop-feb-17.png
// module id = 848
// module chunks = 0